import { type Country } from '@resurs-internal/mui/assets/countries';

import {
  authRedirectUrl,
  baseUrl,
  parseRevokeAccessTokenRequest,
  parseRevokeRefreshTokenRequest,
  parseTokenRequestWithCode,
  parseTokenRequestWithRefreshToken,
  revokeUrl,
  tokenUrl,
} from '@/helpers';
import {
  type AuthTokenResponse,
  type TokenByGrantRequest,
  type TokenRevocationRequest,
} from '@/types/oba-auth-service';

export const authenticateUser = (
  path: string,
  state: string,
  country: Country,
) => {
  window.location.assign(authRedirectUrl(path, state, country));
};

export const getAccessToken = async (code: string, codeVerifier: string) =>
  fetchToken(parseTokenRequestWithCode(code, codeVerifier));

export const refreshAccessToken = async (refreshToken: string) =>
  fetchToken(parseTokenRequestWithRefreshToken(refreshToken));

const fetchToken = async (
  request: TokenByGrantRequest,
): Promise<AuthTokenResponse> => {
  return fetch(tokenUrl, {
    body: new URLSearchParams(request as Record<string, string>),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    mode: 'cors',
  }).then(async (res) => {
    if (res.status !== 200) {
      window.location.assign(baseUrl);
      throw new Error('Could not fetch access token');
    } else {
      return await res.json();
    }
  });
};

export const revokeAccessToken = async (accessToken: string) =>
  revokeToken(parseRevokeAccessTokenRequest(accessToken));

export const revokeRefreshToken = async (refreshToken: string) =>
  revokeToken(parseRevokeRefreshTokenRequest(refreshToken));

const revokeToken = async (request: TokenRevocationRequest) => {
  return fetch(revokeUrl, {
    body: new URLSearchParams(request as Record<string, string>),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    mode: 'cors',
  }).then(async (res) => {
    if (res.status !== 200) {
      throw new Error('Could not revoke access token');
    } else {
      return await res.text();
    }
  });
};
